import { render, staticRenderFns } from "./Svg.vue?vue&type=template&id=5b71619c&scoped=true"
import script from "./Svg.vue?vue&type=script&lang=js"
export * from "./Svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71619c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b71619c')) {
      api.createRecord('5b71619c', component.options)
    } else {
      api.reload('5b71619c', component.options)
    }
    module.hot.accept("./Svg.vue?vue&type=template&id=5b71619c&scoped=true", function () {
      api.rerender('5b71619c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SvgIcon/Svg.vue"
export default component.exports